<template>
  <div class="control radio">
    <label class="radio" v-for="(label, value) in field.options" :key="value">
      <input type="radio" :name="field.name" :value="value" @click="updateFormData">
      {{label}}
    </label>
    <span class="radio-validate">
        <span
          class="icon is-small is-right has-text-danger"
          v-if="!fieldValidator && field.validation.required"
        >
          <fa icon="asterisk" class="fa-xs"></fa>
        </span>
        <span
          class="icon is-small is-right has-text-success"
          v-if="fieldValidator"
        >
          <fa icon="check"></fa>
        </span>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasAnswered: false,
    };
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fieldValidator() {
      return this.hasAnswered;
    },
  },
  methods: {
    updateFormData(e) {
      this.hasAnswered = true;
      this.$store.dispatch('addToSubmission', {
        name: e.target.name,
        value: e.target.value,
      });
    },
  },
  mounted() {
    this.$store.dispatch('addToSubmission', {
      name: this.field.name,
      value: null,
    });
  },
};
</script>
